import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

import { ref, toRefs, onMounted, inject } from "vue"
import { appKey } from "@/main";

interface Props {
  el: HTMLElement;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'ScrollArea',
  props: {
    el: null
  },
  emits: ['update'],
  setup(__props: any, { emit: emits }) {

const props = __props as {
  el: HTMLElement;
};

const app = inject(appKey);



const { el } = toRefs(props);



const scrollY = ref(-5);
const frameH = ref(0);
const frameW = ref(0);
const contentH = ref(0);
const barH = ref(0);
const showScrollBar = ref(true);

const bar = ref();

const updateScroll = (scroll: number) => {
  scrollY.value = (frameH.value - barH.value - 10) * (scroll / (contentH.value - frameH.value));
  emits('update', scrollY.value >= frameH.value - barH.value -20);
  console.log('update', scrollY.value >= frameH.value - barH.value -20)
}
updateScroll(0);

const updateBar = () => {
  try {
    let h = 0;
    for (let i = 0; i<el.value.children[0].children.length; i++) {
      h += el.value.children[0].children[i].clientHeight;
    }
    console.log(h, frameH.value);
    contentH.value = h;
    barH.value = Math.ceil(frameH.value / contentH.value * frameH.value);
    if (barH.value + 10 >= frameH.value) {
      showScrollBar.value = false;
      emits('update', true);
    } else if (!showScrollBar.value) {
      showScrollBar.value = true;
      emits('update', false);
    }
  }
  catch (e) {
    app?.log(e);
  }
}

const mouseStartY = ref(0);
const scrollStartY = ref(0);
const enableControl = ref(false);
const controlBar = ref(false);

const initControl = () => {
  el.value.addEventListener('mousedown', (e: MouseEvent) => {
    controlBar.value = e.pageX > frameW.value;
    mouseStartY.value = e.pageY;
    scrollStartY.value = el.value.children[0].scrollTop;
    enableControl.value = true;
  });

  el.value.addEventListener('mousemove', (e: MouseEvent) => {
    if (!enableControl.value) {
      return;
    }
    e.preventDefault();
    const moveY = mouseStartY.value - e.pageY;
    el.value.children[0].scrollTop = controlBar.value  ? scrollStartY.value - moveY : scrollStartY.value + moveY;
  });

  el.value.addEventListener('mouseup', () => {
    enableControl.value = false;
  });
}

onMounted( () => {
  frameH.value = el.value.children[0].clientHeight;
  frameW.value = el.value.children[0].clientWidth;

  el.value.children[0].addEventListener('scroll', (e: Event) => {
    if (!showScrollBar.value) return;
    if (e.target && e.target instanceof Element) updateScroll(e.target.scrollTop);
  });

  updateBar();
  initControl();
});

setTimeout(() => {
  updateBar();
}, 200);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _renderSlot(_ctx.$slots, "default"),
    (showScrollBar.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "bar",
          style: _normalizeStyle({'top': scrollY.value + 'px', 'height': barH.value + 'px'}),
          ref_key: "bar",
          ref: bar
        }, null, 4))
      : _createCommentVNode("", true)
  ], 64))
}
}

})